import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import FluidImage from 'components/FluidImage';
import cn from 'classnames';

import css from './BoardMember.module.scss';

class BoardMember extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        downloadImageUrl: PropTypes.string,
        downloadImageLabel: PropTypes.string.isRequired,
        className: PropTypes.string
    }

    render() {
        const {
            name,
            title,
            text,
            image,
            downloadImageUrl,
            downloadImageLabel,
            className
        } = this.props;

        return (
            <div className={cn(css.member, {
                [className]: className
            })}>
                <div className={css.image}>
                    <FluidImage image={image} altText={name ? name : ''} className={css.memberImage} />
                    {downloadImageUrl && downloadImageLabel && (
                        <Button
                            block
                            href={downloadImageUrl}
                            secondary
                            target="_blank"
                            className={css.button}
                        >
                            {downloadImageLabel}
                        </Button>
                    )}
                </div>
                <div className={css.info}>
                    <h3 className={css.name}>{name}</h3>
                    <p className={css.title}>{title}</p>
                    <p className={css.text}>{text}</p>
                </div>
            </div>
        );
    }
}

export default BoardMember;



// WEBPACK FOOTER //
// ./src/components/BoardMember/BoardMember.jsx